import './src/main.css'
import CapsuleChart from './src/main.vue'

export default function (Vue) {
  Vue.component(CapsuleChart.name, CapsuleChart)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/capsuleChart/index.js